import {
    Button,
    Dialog,
    DialogActions,
    DialogContentText,
    DialogTitle,
    Typography,
    Box,
} from "@material-ui/core";
import { DialogContent } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import { isEmpty, isNotEmpty } from "../../Utils";
import LinkUpDialogContent from "../LinkUpDialogContent/LinkUpDialogContent";
import LoginBox from "../LoginBox/LoginBox";
import LoginPublic from "../LoginPage/LoginPublic";

export default function LinkUpDialog({ open, onLinkUp, openID, onClose }) {
    const { t } = useTranslation();
    const [linkType, setLinkType] = useState(false);
    console.log("onLinkUp: ", onLinkUp);

    return (
        <Dialog
            // onClose={handleClose}
            aria-labelledby="simple-dialog-title"
            open={open}
        >
            {isNotEmpty(linkType) && (
                <DialogContent>
                    <LinkUpDialogContent openID={openID} onLinkUp={onLinkUp} />
                </DialogContent>
            )}
            <DialogActions
                disableSpacing
                style={{
                    display: "block",
                    textAlign: "center",
                }}
            >
                {isEmpty(linkType) && (
                    <>
                        <Box pb={5}>
                            <Typography>
                                {t("common.iamsmart.linkup.existAccountDesc")}
                            </Typography>
                            <Button
                                onClick={() => {
                                    setLinkType("exist");
                                }}
                                variant="outlined"
                            >
                                {t("common.iamsmart.linkup.existAccount")}
                            </Button>
                        </Box>
                        <Box pb={5}>
                            <Typography>
                                {t("common.iamsmart.linkup.createAccountDesc")}
                            </Typography>
                            <Button
                                onClick={() => {
                                    setLinkType("create");
                                }}
                                variant="outlined"
                            >
                                {t("common.iamsmart.linkup.createAccount")}
                            </Button>
                        </Box>
                    </>
                )}
                <Box>
                    <Typography>
                        {t("common.iamsmart.linkup.cancelLink")}
                    </Typography>
                    <Button
                        variant="outlined"
                        onClick={() => {
                            setLinkType("");
                            onClose();
                        }}
                    >
                        {t("common.cancel")}
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
}
